<template>
  <div>
    <div class="popup_wrap">
      <div v-if="answer.answerResults" class="answer">
        <img
          :src="
            require('../../../../assets/images/powderedMilk/answerTrue.png')
          "
          class="imgTrue"
          alt=""
        />
        <span class="true">答对啦！超棒呦！明天继续</span>
      </div>

      <div v-else class="answer">
        <img
          :src="
            require('../../../../assets/images/powderedMilk/answerFalse.png')
          "
          class="imgTrue"
          alt=""
        />
        <span class="true">答错啦！哎呀,快看专家怎么说！</span>
      </div>

      <div class="progress">
        <div
          class="trueNumber"
          :style="{ width: num(answer.trueNumber, answer.falseNumber) }"
        ></div>
      </div>
      <div class="num">
        <span>是：{{ answer.trueNumber }}人</span>
        <span>否：{{ answer.falseNumber }}人</span>
      </div>
      <div class="doctor">
        <div class="doctor_content">
          <img :src="answer.headImageUrl" alt="" class="doctor_img" />
          <div class="doctor_name">
            <div class="name">{{ answer.realName }}</div>
            <div class="doctor-mag">
              <div class="hospital">{{ answer.hospital }}</div>
              <div class="position">{{ answer.position }}</div>
            </div>
          </div>
        </div>
        <div class="doctor_answer">
          答案：{{ answer.answer == 1 ? "是" : "否" }}
        </div>
      </div>
      <div class="analysis">
        <img
          :src="require('../../../../assets/images/powderedMilk/analysis.png')"
          alt=""
          class="analysis_tag"
        />
        <div class="analysis-content">{{ answer.analysis }}</div>
      </div>
      <div class="history" @click="ToHistory">
        查看以往问题
        <img
          :src="require('../../../../assets/images/powderedMilk/xiayiye.png')"
          alt=""
          class="his_more"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Index from "./js/index.js";
export default Index;
</script>
<style lang="less" scoped>
@import "./less/index.less";
</style>